import React, { Component } from 'react';
import '../App.css';
import Header from '../header/header.js'
class About extends Component {

  render() {
    return (
 <div className="aboutPadre">
  <div className='aboutHijoUno'>
    <div className='aboutHijoDosUno '>
<p>
  <span className='estiloSpan' >Interactive Media Design </span>
student interested in working in a competitive industry that is concerned with <span className='estiloSpan' >creativity, knowledge and innovation, </span> more specifically in the areas of Front-end Development, Digital Product Development with
  <span className='estiloSpan' > agile methodologies and Ux, </span>as well as Interactive Experience Design.</p>
    </div>
  </div>
  <div className='aboutHijoDos'>
 <img src={require('../resources/images/about/julianMadrid.png')} className='imagenJulian'/>
  </div>
 </div>
    );
  }
}
export default About;



// WEBPACK FOOTER //
// ./src/about/about.js